
        <div class=" col-12 col-md-6 offset-md-3 ">


                <div class="row mt-2">
                    <div class="col-12  col-md-8 offset-md-2">
                        <h5 class=" text-secondary text-center">
                            <i class="  fas fa-user"></i> Estadisticas de registros de clientes
                        </h5>
                    </div>
                </div>

                <!-- Indicador de Estado del Registro -->
                <div class="mt-4 mb-3" *ngIf="!registrationConfigLoading && registrationConfig">
                    <div class="p-3 bg-body rounded shadow-sm border">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <div class="me-3">
                                    <i class="fas fa-circle" 
                                       [class.text-success]="registrationConfig?.params?.enable" 
                                       [class.text-danger]="!registrationConfig?.params?.enable"
                                       style="font-size: 1.2rem;"></i>
                                </div>
                                <div>
                                    <h6 class="mb-0 fw-bold">Estado del Registro de Usuarios</h6>
                                    <small class="text-muted">
                                        {{ registrationConfig?.params?.enable ? 'Registro Habilitado' : 'Registro Deshabilitado' }}
                                    </small>
                                </div>
                            </div>
                            <button *ngIf="_auth.hasPermission('credito.registro.update')" class="btn btn-sm btn-outline-primary" (click)="openRegistrationModal()">
                                <i class="fas fa-edit me-1"></i> Editar Registro
                            </button>
                        </div>
                    </div>
                </div>
                

                <ng-container *ngIf="loading ">
                    <div class="w-100 text-center mt-3">
                        <img src="./assets/public/images/loading.gif  " alt=" ">
                    </div>
                </ng-container>

            <div class="mt-5" *ngIf="!loading ">


                <div class="float-end text-primary" *ngIf="!reloadStadisticLoading">
                    <i (click)="stadisticGet(false)" class="fas fa-sync-alt"></i>
                </div>
                <div class=" small" *ngIf="!reloadStadisticLoading"> Ult. actualización {{client_stadistic?.date  | date: 'dd/MM/yyyy h:mm:ss a'}} 

                </div>

                <div class=" small " *ngIf="reloadStadisticLoading"> actualizando... 

                </div>

                
            </div>

            <div *ngIf="!loading " class="mt-2 my-3 p-3 bg-body rounded shadow-sm">
                <ng-container>

                    <h4 class="text-secondary mt-2">Registros</h4>


                    <div class=" d-flex text-dark pt-3" *ngFor="let item of stadistic?.clients[0]?.statuses">
                        <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                            <div class="d-flex justify-content-between">
                                <span class="text-gray-dark"> {{item?.status?'App':'Consola'}}
                                </span>

                                <span >
                                    {{item?.count}}
                                </span>
                            </div>

                        </div>
                    </div>

                    <div class=" d-flex text-dark pt-3">
                        <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                            <div class="d-flex justify-content-between">
                                <span class="text-gray-dark  fw-bold "> Total Registros
                                </span>

                                <span class="fw-bold">
                                    {{stadistic?.clients[0]?.total}}
                                </span>
                            </div>

                        </div>
                    </div>

                </ng-container>
            
        </div>


        <div *ngIf="!loading " class="mt-3 my-3 p-3 bg-body rounded shadow-sm">
            <ng-container>
                <h4 class="text-secondary mt-2">Biometria</h4>


                <div class=" d-flex text-dark pt-3" *ngFor="let item of stadistic?.status_biometric[0]?.statuses">
                    <div class="pb-3 mb-0 small lh-sm border-bottom w-100" *ngIf="item?.status != 'sin estatus'">
                        <div class="d-flex justify-content-between">
                            <span class="text-gray-dark"> {{item?.status}}
                            </span>

                            <span >
                                {{item?.count}}
                            </span>
                        </div>

                    </div>
                </div>

                <div class=" d-flex text-dark pt-3">
                    <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                        <div class="d-flex justify-content-between">
                            <span class="text-gray-dark  fw-bold "> Sin Biometria
                            </span>

                            <span class="fw-bold">
                                {{stadistic?.status_biometric[0]?.sinBiometria}}
                            </span>
                        </div>

                    </div>
                </div>

                <div class=" d-flex text-dark pt-3">
                    <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                        <div class="d-flex justify-content-between">
                            <span class="text-gray-dark  fw-bold "> Con Biometria
                            </span>

                            <span class="fw-bold">
                                {{stadistic?.status_biometric[0]?.conBiometria}}
                            </span>
                        </div>

                    </div>
                </div>

                <div class=" d-flex text-dark pt-3">
                    <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                        <div class="d-flex justify-content-between">
                            <span class="text-gray-dark  fw-bold "> Incompletos
                            </span>

                            <span class="fw-bold">
                                {{stadistic?.status_biometric[0]?.incompletos}}
                            </span>
                        </div>

                    </div>
                </div>

                <div class=" d-flex text-dark pt-3">
                    <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                    <div class="d-flex justify-content-between">
                        <span class="text-gray-dark  fw-bold "> Completados
                        </span>

                        <span class="fw-bold">
                            {{stadistic?.status_biometric[0]?.completados}}
                        </span>
                    </div>

                </div>
            </div>

            
            

            </ng-container>
           


    </div>


    <div *ngIf="!loading " class="mt-3 my-3 p-3 bg-body rounded shadow-sm">
        <ng-container>
            <h4 class="text-secondary mt-2">Onboarding</h4>


            <div class=" d-flex text-dark pt-3" *ngFor="let item of stadistic?.ob_sections">
                <div class="pb-3 mb-0 small lh-sm border-bottom w-100" *ngIf="item?.status != 'sin estatus'">
                    <div class="d-flex justify-content-between">
                        <span class="text-gray-dark"> {{item?.section?.name}}
                        </span>

                        <span >
                            {{item?.total}} / <span class="text-warning">{{stadistic?.total_APK - item?.total}}</span>
                        </span>
                    </div>

                </div>
            </div>

            <br>


            <div class=" d-flex text-dark pt-3" *ngFor="let item of stadistic?.ob_total[0]?.statuses">
                <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                    <div class="d-flex justify-content-between">
                        <span class="text-gray-dark fw-bold text-lowercase"> {{item?.status}}
                        </span>

                        
                        <span class=" fw-bold" *ngIf="item?.status != 'IN_PROGRES'" >
                            {{item?.count }}  
                        </span>

                        <span class=" fw-bold" *ngIf="item?.status == 'IN_PROGRES'" >
                            
                            {{item?.count - stadistic?.ob_sin_enviar[0]?.total }} 

                        </span>
                        
                    </div>

                </div>
            </div>

            
            <div class=" d-flex text-dark pt-3" >
                <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                    <div class="d-flex justify-content-between">
                        <span class="text-gray-dark fw-bold">Pendiente por enviar
                        </span>

                        <span class=" fw-bold" >
                            {{ stadistic?.ob_sin_enviar[0]?.total}}
                        </span>
                    </div>

                </div>
            </div>

        </ng-container>
    
</div>

<div *ngIf="!loading " class="mt-3 my-3 p-3 bg-body rounded shadow-sm">
    <ng-container>

        <h4 class="text-secondary mt-2">Analisis de aprobación</h4>


        <div class=" d-flex text-dark pt-3" *ngFor="let item of stadistic?.aprobacion[0]?.statuses">
            <div class="pb-3 mb-0 small lh-sm border-bottom w-100" *ngIf="item?.status != '-'" >
                <div class="d-flex justify-content-between">
                    <span class="text-gray-dark"> {{item?.status}}
                    </span>

                    <span  *ngIf="item?.status != 'sin analisis'">
                       {{item?.count}} 
                    </span>

                    <span  *ngIf="item?.status == 'sin analisis'">
                     {{ item?.count + (stadistic?.total_raya > 0 ? stadistic?.total_raya :0)}}
                    </span>
                </div>

            </div>
        </div>

        <div class=" d-flex text-dark pt-3">
            <div class="pb-3 mb-0 small lh-sm border-bottom w-100">
                <div class="d-flex justify-content-between">
                    <span class="text-gray-dark  fw-bold "> Total Registros
                    </span>

                    <span class="fw-bold">
                        {{stadistic?.aprobacion[0]?.total}}
                    </span>
                </div>

            </div>
        </div>

    </ng-container>

     </div>
 
    </div>


<!-- Modal Lateral para Control de Registro -->
<div class="registration-modal-overlay" *ngIf="showRegistrationModal" (click)="closeRegistrationModal()">
</div>

<div class="registration-modal-sidebar" [class.show]="showRegistrationModal">
    <div class="modal-sidebar-header">
        <h5 class="mb-0 fw-bold">
            <i class="fas fa-cog me-2"></i>
            Control de Registro de Usuarios
        </h5>
        <button type="button" class="btn-close" (click)="closeRegistrationModal()" aria-label="Close"></button>
    </div>

    <div class="modal-sidebar-body">
        <!-- Loader mientras se procesa -->
        <div *ngIf="registrationModalLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="mt-3 text-muted">Procesando cambios...</p>
        </div>

        <!-- Contenido del modal -->
        <div *ngIf="!registrationModalLoading">
            <!-- Toggle Switch para Habilitar/Deshabilitar Registro -->
            <div class="card shadow-sm mb-4">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 class="mb-1 fw-bold">Habilitar Registro de Usuarios</h6>
                            <small class="text-muted">
                                {{ registrationConfig?.params?.enable ? 'El registro está actualmente habilitado' : 'El registro está actualmente deshabilitado' }}
                            </small>
                        </div>
                        <div class="form-check form-switch" style="font-size: 1.5rem;">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                role="switch" 
                                id="registrationToggle"
                                [checked]="registrationConfig?.params?.enable"
                                (change)="toggleRegistration()"
                                style="cursor: pointer;">
                        </div>
                    </div>

                    <!-- Indicador visual del estado -->
                    <div class="mt-3 p-2 rounded" 
                         [class.bg-success]="registrationConfig?.params?.enable"
                         [class.bg-opacity-10]="registrationConfig?.params?.enable"
                         [class.bg-danger]="!registrationConfig?.params?.enable"
                         [class.bg-opacity-10]="!registrationConfig?.params?.enable">
                        <small class="d-flex align-items-center">
                            <i class="fas fa-info-circle me-2"></i>
                            <span *ngIf="registrationConfig?.params?.enable">
                                Los usuarios pueden registrarse normalmente en la aplicación.
                            </span>
                            <span *ngIf="!registrationConfig?.params?.enable">
                                Los nuevos usuarios no podrán registrarse y verán el mensaje configurado.
                            </span>
                        </small>
                    </div>
                </div>
            </div>

            <!-- Formulario para Editar Mensaje -->
            <div class="card shadow-sm">
                <div class="card-body">
                    <h6 class="mb-3 fw-bold">
                        <i class="fas fa-comment-alt me-2"></i>
                        Mensaje de Registro Deshabilitado
                    </h6>
                    
                    <div class="alert alert-warning py-2 small" role="alert">
                        <i class="fas fa-exclamation-triangle me-1"></i>
                        Este mensaje se mostrará a los usuarios cuando intenten registrarse y el registro esté deshabilitado.
                    </div>

                    <div class="mb-3">
                        <label for="registrationMessage" class="form-label small fw-bold">Mensaje</label>
                        <textarea 
                            class="form-control" 
                            id="registrationMessage"
                            rows="4"
                            [(ngModel)]="registrationMessageForm"
                            [class.is-invalid]="registrationMessageError"
                            placeholder="Ingrese el mensaje que verán los usuarios..."></textarea>
                        <div class="invalid-feedback" *ngIf="registrationMessageError">
                            {{ registrationMessageError }}
                        </div>
                        <small class="text-muted d-block mt-1">
                            Caracteres: {{ registrationMessageForm?.length || 0 }}
                        </small>
                    </div>

                    <button 
                        class="btn btn-primary w-100 mt-2"
                        (click)="saveRegistrationMessage()"
                        [disabled]="!registrationMessageForm || registrationMessageForm.trim().length === 0">
                        <i class="fas fa-save me-2"></i>
                        Guardar Mensaje
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-sidebar-footer">
        <button type="button" class="btn btn-secondary" (click)="closeRegistrationModal()">
            <i class="fas fa-times me-2"></i>
            Cerrar
        </button>
    </div>
</div>

